 
    <div class="row">
      <div class="col-12 text-center bg-white shadow p-4">
        <img src="../../../assets/images/empty-data.jpg" alt="Placeholder Image" class="img-fluid" width="250px" height="auto">
        <h3 class="mt-3">No data available</h3>
        <p>There is no data to display at the moment.</p>
      </div>
    </div> 